// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ImrX","top":"styles_top__9LyfS"};